<template>
  <SliderForm :isEdit="true" :sliderId="$route.params.id" />
</template>

<script>
import SliderForm from "@/components/sliders/SliderForm.vue";

export default {
  name: "SliderEditPage",
  components: {
    SliderForm,
  },
};
</script>
